import { Dispatch } from '@reduxjs/toolkit';
import qs from 'qs';
import { batch } from 'react-redux';

import SessionClientDashboard from 'dashboard/lib/clients/SessionClientDashboard';
import { MessageType } from 'dashboard/lib/interfaces/Message';
import { Blueprint, BlueprintPreview } from 'dashboard/models/blueprint';
import {
  addBlueprints,
  setBlueprintPreview,
  setBlueprints,
} from 'dashboard/redux/actions/blueprints';
import { showMessage } from 'dashboard/redux/actions/messages';
import { DashboardThunkAction } from 'dashboard/redux/types';
import { ApiEndpoint, ApiModel } from 'lib/interfaces/api';

export function loadBlueprints(): DashboardThunkAction<Promise<void>> {
  return async (dispatch: Dispatch): Promise<void> => {
    const blueprintsResponse = await SessionClientDashboard.listResource<Blueprint>(
      ApiEndpoint.Blueprint,
    );
    const blueprints = blueprintsResponse.data;

    batch(() => {
      dispatch(setBlueprints(blueprints));
    });
  };
}

export function addBlueprint(blueprintKey: string): DashboardThunkAction<Promise<void>> {
  return async (dispatch: Dispatch): Promise<void> => {
    try {
      const response = await SessionClientDashboard.postResourceCreate<Blueprint>({
        type: ApiModel.Blueprint,
        attributes: {
          'source-type': blueprintKey,
        },
      });

      const blueprint = response.data;

      batch(() => {
        dispatch(addBlueprints([blueprint]));
      });
    } catch (err) {
      /* @ts-expect-error [strict-migration] The following line is not strict; please fix! */
      if (err && err.status === 403 && err.errors?.[0]?.code === 'active_template_limit_error') {
        dispatch(
          showMessage(
            'Your current plan only supports five active templates. Please contact our team if you’d like to learn more.',
            MessageType.Notice,
          ),
        );
      } else {
        dispatch(
          showMessage(
            'An error occurred when adding this solution. Please try again.',
            MessageType.Failure,
          ),
        );
      }
    }
  };
}

export function loadBlueprintPreview(blueprintKey: string): DashboardThunkAction<Promise<void>> {
  return async (dispatch: Dispatch): Promise<void> => {
    try {
      const blueprintPreview = await SessionClientDashboard.getResourceMeta<BlueprintPreview>(
        ApiEndpoint.Blueprint,
        `preview?${qs.stringify({ blueprint_source_type: blueprintKey })}`,
      );

      /* @ts-expect-error [strict-migration] The following line is not strict; please fix! */
      dispatch(setBlueprintPreview(blueprintKey, blueprintPreview.meta));
    } catch (err) {
      dispatch(
        showMessage(
          'An error occurred when previewing this solution. Please try again.',
          MessageType.Failure,
        ),
      );
    }
  };
}
